// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import {
//     HelpCircle,
//     Mail,
//     MessageCircle,
//     Search,
//     ChevronDown,
//     ChevronUp,
//     ThumbsUp,
//     ThumbsDown,
//     Eye,
//     BookOpen,
//     Zap,
//     Users,
//     Globe,
//     Sparkles,
//     CheckCircle,
//     ArrowRight,
//     Star,
//     TrendingUp,
// } from "lucide-react";
// import BackToTop from "../../components/BackToTop/BackToTop";
// import Footer from "../../layouts/Footer";
// import Header from "../../layouts/Header";
// import HeroBg from "../../../src/images/hero-bg.png";

// const Support = () => {
//     const [searchQuery, setSearchQuery] = useState("");
//     const [activeCategory, setActiveCategory] = useState("all");
//     const [expandedFaq, setExpandedFaq] = useState(null);
//     const [feedback, setFeedback] = useState({});
//     const [searchFocused, setSearchFocused] = useState(false);

//     const categories = [
//         { id: "all", name: "All Questions", icon: HelpCircle, color: "gray" },
//         { id: "getting-started", name: "Getting Started", icon: Zap, color: "blue" },
//         { id: "account", name: "Account & Billing", icon: Users, color: "green" },
//         { id: "technical", name: "Technical", icon: Globe, color: "purple" },
//         { id: "tutorials", name: "Tutorials", icon: BookOpen, color: "orange" },
//     ];

//     const faqs = [
//         {
//             id: 1,
//             category: "getting-started",
//             question: "How do I create my first CTV ad?",
//             answer: "Creating your first CTV ad is simple:\n\n1. Sign up for a free account at SocialTV\n2. Click 'Create New Ad' in your dashboard\n3. Choose a template from our library\n4. Paste your social media video URL\n5. Customize with your brand colors and logo\n6. Preview your ad and generate a VAST tag\n\nYour ad will be ready in under 5 minutes!",
//             views: 1234,
//             helpful: 89,
//             trending: true
//         },
//         {
//             id: 2,
//             category: "getting-started",
//             question: "What platforms can I import content from?",
//             answer: "We support imports from all major social platforms:\n\n• Instagram (Reels, Posts, Stories)\n• TikTok\n• Facebook (Videos, Reels)\n• X (Twitter)\n• Pinterest\n• YouTube\n• Vimeo\n\nSimply paste the video URL and our AI will automatically optimize it for TV display.",
//             views: 2341,
//             helpful: 95,
//             popular: true
//         },
//         {
//             id: 3,
//             category: "account",
//             question: "How do I cancel my subscription?",
//             answer: "To cancel your subscription:\n\n1. Log into your SocialTV account\n2. Go to Settings > Billing\n3. Click 'Manage Subscription'\n4. Select 'Cancel Subscription'\n5. Confirm cancellation\n\nYour access will continue until the end of your current billing period. No further charges will be made.",
//             views: 3456,
//             helpful: 92,
//             trending: true
//         },
//         {
//             id: 4,
//             category: "account",
//             question: "What payment methods do you accept?",
//             answer: "We accept all major payment methods:\n\n• Credit/Debit Cards (Visa, MasterCard, American Express)\n• PayPal\n• Bank transfers (for annual enterprise plans)\n• Apple Pay\n• Google Pay\n\nAll payments are processed securely through Stripe.",
//             views: 1567,
//             helpful: 88
//         },
//         {
//             id: 5,
//             category: "technical",
//             question: "What is a VAST tag and how do I use it?",
//             answer: "VAST (Video Ad Serving Template) is a universal format that allows video ads to be served across different platforms.\n\nTo use your VAST tag:\n\n1. Create your ad in SocialTV\n2. Copy the VAST tag URL from your dashboard\n3. Paste it into your ad server (Google Ad Manager, The Trade Desk, etc.)\n4. The ad server will pull your video and display it on CTV platforms\n\nYour VAST tag is compatible with all major platforms including Roku, Amazon Fire TV, and Samsung TV Plus.",
//             views: 4321,
//             helpful: 96,
//             popular: true,
//             trending: true
//         },
//         {
//             id: 6,
//             category: "technical",
//             question: "What video formats and resolutions do you support?",
//             answer: "We support the following formats:\n\n• Video: MP4, MOV, AVI\n• Resolution: Up to 4K (3840x2160)\n• Aspect Ratios: 16:9, 9:16, 1:1, 4:5\n• Frame Rate: Up to 60fps\n• Audio: AAC, MP3\n\nOur platform automatically optimizes your video for the best quality on TV screens.",
//             views: 2876,
//             helpful: 91
//         },
//         {
//             id: 7,
//             category: "tutorials",
//             question: "How do I add my logo and branding?",
//             answer: "Adding your branding is easy:\n\n1. In the ad editor, click 'Branding'\n2. Upload your logo (PNG or SVG recommended)\n3. Choose logo position\n4. Select your brand colors for text overlays\n5. Preview to see how it looks\n\nYour branding will be automatically applied to all your ads.",
//             views: 1987,
//             helpful: 94,
//             popular: true
//         },
//         {
//             id: 8,
//             category: "tutorials",
//             question: "Can I schedule my ads to run at specific times?",
//             answer: "Yes! With our Pro and Enterprise plans, you can:\n\n• Set start and end dates for campaigns\n• Schedule ads for specific times of day\n• Target specific days of the week\n• Set frequency caps per user\n• Create custom schedules for different platforms",
//             views: 1654,
//             helpful: 93
//         }
//     ];

//     const filteredFaqs = faqs.filter(faq => {
//         const matchesCategory = activeCategory === "all" || faq.category === activeCategory;
//         const matchesSearch = searchQuery === "" ||
//             faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
//             faq.answer.toLowerCase().includes(searchQuery.toLowerCase());
//         return matchesCategory && matchesSearch;
//     });

//     const handleFaqClick = (id) => {
//         setExpandedFaq(expandedFaq === id ? null : id);
//     };

//     const handleFeedback = (faqId, type) => {
//         setFeedback(prev => ({
//             ...prev,
//             [faqId]: type
//         }));
//     };

//     const getCategoryColor = (categoryId) => {
//         const colors = {
//             "getting-started": "bg-blue-100 text-blue-700 border-blue-200",
//             "account": "bg-green-100 text-green-700 border-green-200",
//             "technical": "bg-purple-100 text-purple-700 border-purple-200",
//             "tutorials": "bg-orange-100 text-orange-700 border-orange-200"
//         };
//         return colors[categoryId] || "bg-gray-100 text-gray-700 border-gray-200";
//     };

//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, []);

//     return (
//         <div className="bg-gradient-to-b from-gray-50 to-white">
//             <BackToTop />

//             {/* ================= HEADER ================= */}
//             <Header />

//             <div className="relative">

//                 <div className="absolute inset-0 w-full h-full">
//                     <img
//                         src={HeroBg}
//                         loading="lazy"
//                         sizes="(max-width: 1440px) 100vw, 1440px"
//                         alt="hero"
//                         className="w-full h-full object-cover"
//                     />
//                 </div>

//                 {/* <div className="absolute inset-0 overflow-hidden">
//                     <div className="absolute top-0 -left-40 w-[400px] h-[400px] bg-gradient-to-r from-indigo-200/20 via-purple-200/20 to-pink-200/20 rounded-full blur-3xl animate-float-slow"></div>
//                     <div className="absolute bottom-0 -right-40 w-[400px] h-[400px] bg-gradient-to-l from-pink-200/20 via-purple-200/20 to-indigo-200/20 rounded-full blur-3xl animate-float-slower"></div>

//                     {[...Array(50)].map((_, i) => (
//                         <div
//                             key={i}
//                             className="absolute w-1 h-1 bg-gradient-to-r from-indigo-400 to-purple-400 rounded-full animate-float-particle"
//                             style={{
//                                 left: `${Math.random() * 100}%`,
//                                 top: `${Math.random() * 100}%`,
//                                 animationDelay: `${Math.random() * 8}s`,
//                                 animationDuration: `${15 + Math.random() * 15}s`,
//                                 opacity: 0.2,
//                             }}
//                         />
//                     ))}
//                 </div> */}

//                 {/* Main Content */}
//                 <main className="max-w-5xl mx-auto px-6 py-20 relative">
//                     {/* Hero with animation */}
//                     <div className="text-center my-16 animate-fade-in">
//                         <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full mb-6 hover:shadow-md transition-shadow">
//                             <Sparkles className="h-4 w-4 text-indigo-600" />
//                             <span className="text-sm font-medium text-indigo-600">24/7 Support</span>
//                         </div>
//                         <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
//                             How can we{' '}
//                             <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
//                                 help you?
//                             </span>
//                         </h1>
//                         <p className="text-lg text-gray-500 max-w-2xl mx-auto">
//                             Search our help center or browse the topics below to find answers
//                         </p>
//                     </div>

//                     {/* Search with focus effect */}
//                     <div className="max-w-2xl mx-auto mb-16">
//                         <div className={`relative transition-all duration-300 ${searchFocused ? 'scale-105' : ''}`}>
//                             <Search className={`absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 transition-colors duration-300 ${searchFocused ? 'text-indigo-600' : 'text-gray-400'}`} />
//                             <input
//                                 type="text"
//                                 placeholder="Search for answers..."
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                                 onFocus={() => setSearchFocused(true)}
//                                 onBlur={() => setSearchFocused(false)}
//                                 className="w-full pl-12 pr-4 py-4 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent shadow-sm hover:shadow-md transition-all"
//                             />
//                             {searchQuery && (
//                                 <button
//                                     onClick={() => setSearchQuery("")}
//                                     className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
//                                 >
//                                     ×
//                                 </button>
//                             )}
//                         </div>
//                     </div>



//                     {/* FAQ Section */}
//                     <div className="mb-16">
//                         <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
//                             <h2 className="text-xl font-semibold text-gray-900">Frequently asked questions</h2>

//                             {/* Category Tabs with animation */}
//                             {/* <div className="flex gap-1 p-1 bg-gray-100 rounded-lg">
//                             {categories.map((category) => (
//                                 <button
//                                     key={category.id}
//                                     onClick={() => setActiveCategory(category.id)}
//                                     className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-300 flex items-center gap-2 ${activeCategory === category.id
//                                         ? "bg-white text-indigo-600 shadow-md"
//                                         : "text-gray-600 hover:text-indigo-600"
//                                         }`}
//                                 >
//                                     <category.icon className="h-4 w-4" />
//                                     <span className="hidden sm:inline">{category.name}</span>
//                                 </button>
//                             ))}
//                         </div> */}
//                         </div>

//                         <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
//                             {/* <h2 className="text-lg font-semibold text-gray-900">Frequently asked questions</h2> */}

//                             {/* Category Tabs with icons and text always visible */}
//                             <div className="flex flex-wrap gap-3">
//                                 {categories.map((category) => (
//                                     <button
//                                         key={category.id}
//                                         onClick={() => setActiveCategory(category.id)}
//                                         className={`px-4 py-2.5 text-sm font-medium rounded-xl transition-all duration-300 flex items-center gap-2 ${activeCategory === category.id
//                                             ? "border border-transparent bg-indigo-600 text-white shadow-lg shadow-indigo-200 "
//                                             : "bg-white text-gray-600 border border-gray-200 hover:border-indigo-300 hover:text-indigo-600 hover:bg-indigo-50/50"
//                                             }`}
//                                     >
//                                         <category.icon className={`h-4 w-4 ${activeCategory === category.id ? "text-white" : "text-gray-500"
//                                             }`} />
//                                         <span>{category.name}</span>

//                                         {/* Optional: Add count badge */}
//                                         <span className={`text-xs px-1.5 py-0.5 rounded-full ${activeCategory === category.id
//                                             ? "bg-white/20 text-white"
//                                             : "bg-gray-100 text-gray-500"
//                                             }`}>
//                                             {faqs.filter(f => f.category === category.id || category.id === "all").length}
//                                         </span>
//                                     </button>
//                                 ))}
//                             </div>
//                         </div>

//                         {/* FAQ Accordion with animations */}
//                         <div className="space-y-5">
//                             {filteredFaqs.length > 0 ? (
//                                 filteredFaqs.map((faq) => (
//                                     <div
//                                         key={faq.id}
//                                         className="border border-gray-200 rounded-xl overflow-hidden hover:border-indigo-200 transition-all duration-300 hover:shadow-md"
//                                     >
//                                         <button
//                                             onClick={() => handleFaqClick(faq.id)}
//                                             className="w-full px-6 py-4 text-left flex items-center justify-between gap-4 bg-white transition-colors group"
//                                         >
//                                             <div className="flex-1">
//                                                 <div className="flex items-center gap-2 mb-1">
//                                                     <span className={`text-xs px-2 py-0.5 rounded-full ${getCategoryColor(faq.category)}`}>
//                                                         {categories.find(c => c.id === faq.category)?.name}
//                                                     </span>
//                                                     {faq.trending && (
//                                                         <span className="text-xs bg-orange-100 text-orange-600 px-2 py-0.5 rounded-full flex items-center gap-1">
//                                                             <TrendingUp className="h-3 w-3" /> Trending
//                                                         </span>
//                                                     )}
//                                                     {faq.popular && (
//                                                         <span className="text-xs bg-purple-100 text-purple-600 px-2 py-0.5 rounded-full flex items-center gap-1">
//                                                             <Star className="h-3 w-3 fill-purple-600" /> Popular
//                                                         </span>
//                                                     )}
//                                                 </div>
//                                                 <span className="font-medium text-gray-900 group-hover:text-indigo-600 transition-colors">
//                                                     {faq.question}
//                                                 </span>
//                                             </div>
//                                             <div className={`p-1 rounded-full transition-all duration-300 ${expandedFaq === faq.id
//                                                 ? 'bg-indigo-100 rotate-180'
//                                                 : 'bg-gray-100 group-hover:bg-indigo-100'
//                                                 }`}>
//                                                 {expandedFaq === faq.id ? (
//                                                     <ChevronUp className="h-5 w-5 text-indigo-600" />
//                                                 ) : (
//                                                     <ChevronDown className="h-5 w-5 text-gray-500 group-hover:text-indigo-600" />
//                                                 )}
//                                             </div>
//                                         </button>

//                                         {/* Expandable answer with animation */}
//                                         <div className={`transition-all duration-300 overflow-hidden ${expandedFaq === faq.id ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
//                                             }`}>
//                                             {expandedFaq === faq.id && (
//                                                 <div className="px-6 pb-6 border-t border-gray-100 bg-white">
//                                                     <div className="pt-4">
//                                                         <p className="text-gray-600 whitespace-pre-line leading-relaxed">
//                                                             {faq.answer}
//                                                         </p>

//                                                         <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mt-6 pt-4 border-t border-gray-200">
//                                                             <div className="flex items-center gap-4">
//                                                                 <div className="flex items-center gap-1 text-sm text-gray-500">
//                                                                     <Eye className="h-4 w-4" />
//                                                                     {faq.views.toLocaleString()} views
//                                                                 </div>
//                                                                 <div className="flex items-center gap-1 text-sm text-gray-500">
//                                                                     <ThumbsUp className="h-4 w-4" />
//                                                                     {faq.helpful}% helpful
//                                                                 </div>
//                                                             </div>

//                                                             <div className="flex items-center gap-3">
//                                                                 <span className="text-sm text-gray-500">Was this helpful?</span>
//                                                                 <div className="flex gap-2">
//                                                                     <button
//                                                                         onClick={() => handleFeedback(faq.id, 'yes')}
//                                                                         className={`p-2 rounded-lg transition-all duration-300 transform hover:scale-110 ${feedback[faq.id] === 'yes'
//                                                                             ? 'bg-green-100 text-green-600'
//                                                                             : 'bg-white border border-gray-200 text-gray-400 hover:bg-green-50 hover:text-green-600 hover:border-green-200'
//                                                                             }`}
//                                                                     >
//                                                                         <ThumbsUp className="h-4 w-4" />
//                                                                     </button>
//                                                                     <button
//                                                                         onClick={() => handleFeedback(faq.id, 'no')}
//                                                                         className={`p-2 rounded-lg transition-all duration-300 transform hover:scale-110 ${feedback[faq.id] === 'no'
//                                                                             ? 'bg-red-100 text-red-600'
//                                                                             : 'bg-white border border-gray-200 text-gray-400 hover:bg-red-50 hover:text-red-600 hover:border-red-200'
//                                                                             }`}
//                                                                     >
//                                                                         <ThumbsDown className="h-4 w-4" />
//                                                                     </button>
//                                                                 </div>
//                                                             </div>
//                                                         </div>

//                                                         {/* Feedback thank you message */}
//                                                         {feedback[faq.id] && (
//                                                             <div className="mt-4 flex items-center gap-2 text-sm text-green-600 animate-fade-in">
//                                                                 <CheckCircle className="h-4 w-4" />
//                                                                 Thank you for your feedback!
//                                                             </div>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </div>
//                                     </div>
//                                 ))
//                             ) : (
//                                 <div className="text-center py-16 bg-gray-50 rounded-xl border border-gray-200">
//                                     <HelpCircle className="h-12 w-12 text-gray-300 mx-auto mb-3" />
//                                     <p className="text-gray-600">No results found for "{searchQuery}"</p>
//                                     <button
//                                         onClick={() => setSearchQuery("")}
//                                         className="mt-2 text-indigo-600 hover:text-indigo-700 hover:underline transition-all"
//                                     >
//                                         Clear search
//                                     </button>
//                                 </div>
//                             )}
//                         </div>
//                     </div>

//                     {/* Contact Options with hover effects */}
//                     <div className="grid md:grid-cols-2 gap-6">
//                         <Link
//                             to="/contact"
//                             className="group p-8 bg-gradient-to-br from-indigo-600 to-indigo-700 rounded-2xl text-white hover:shadow-xl transition-all duration-300 hover:-translate-y-1 relative overflow-hidden"
//                         >
//                             {/* Animated background effect */}
//                             <div className="absolute inset-0 bg-white/10 translate-y-full group-hover:translate-y-0 transition-transform duration-500"></div>

//                             <MessageCircle className="h-8 w-8 mb-4 relative z-10 group-hover:scale-110 transition-transform duration-300" />
//                             <h3 className="text-xl font-semibold mb-2 relative z-10">Contact support</h3>
//                             <p className="text-indigo-100 mb-4 relative z-10">Get help from our support team</p>
//                             <span className="inline-flex items-center gap-1 text-white/90 group-hover:text-white relative z-10">
//                                 Send message <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
//                             </span>
//                         </Link>

//                         <a
//                             href="mailto:support@socialtv.com"
//                             className="group p-8 bg-white border border-gray-200 rounded-2xl hover:border-indigo-200 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 relative overflow-hidden"
//                         >
//                             <div className="absolute inset-0 bg-gradient-to-r from-indigo-50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

//                             <Mail className="h-8 w-8 text-indigo-600 mb-4 relative z-10 group-hover:scale-110 transition-transform duration-300" />
//                             <h3 className="text-xl font-semibold text-gray-900 mb-2 relative z-10">Email us</h3>
//                             <p className="text-gray-500 mb-4 relative z-10">support@socialtv.com</p>
//                             <span className="inline-flex items-center gap-1 text-indigo-600 relative z-10">
//                                 Send email <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
//                             </span>
//                         </a>
//                     </div>

//                     {/* Quick help footer */}
//                     <div className="mt-12 text-center">
//                         <p className="text-gray-400 text-sm">
//                             Our support team typically responds within{' '}
//                             <span className="text-gray-600 font-medium">24 hours</span>
//                         </p>
//                     </div>

//                 </main>
//             </div>

//             {/* ================= FOOTER ================= */}
//             <Footer />

//         </div>
//     );
// };

// export default Support;

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
    HelpCircle,
    Mail,
    MessageCircle,
    Search,
    ChevronDown,
    ChevronUp,
    ThumbsUp,
    ThumbsDown,
    Eye,
    BookOpen,
    Zap,
    Users,
    Globe,
    Sparkles,
    CheckCircle,
    ArrowRight,
    Star,
    TrendingUp,
} from "lucide-react";

import BackToTop from "../../components/BackToTop/BackToTop";
import Footer from "../../layouts/Footer";
import Header from "../../layouts/Header";
import HeroBg from "../../../src/images/hero-bg.png";
import AuthPopup from "../../components/popup/AuthPopup";

const Support = () => {
    const [searchQuery, setSearchQuery] = useState("");
    const [activeCategory, setActiveCategory] = useState("all");
    const [expandedFaq, setExpandedFaq] = useState(null);
    const [feedback, setFeedback] = useState({});
    const [searchFocused, setSearchFocused] = useState(false);
    const [showAuth, setShowAuth] = useState(false);

    const categories = [
        {
            id: "all",
            name: "All Questions",
            icon: HelpCircle,
        },
        {
            id: "getting-started",
            name: "Getting Started",
            icon: Zap,
        },
        {
            id: "account",
            name: "Account & Billing",
            icon: Users,
        },
        {
            id: "technical",
            name: "Technical",
            icon: Globe,
        },
        {
            id: "tutorials",
            name: "Tutorials",
            icon: BookOpen,
        },
    ];

    const faqs = [
        {
            id: 1,
            category: "getting-started",
            question: "How do I create my first CTV ad?",
            answer: `Creating your first CTV ad is simple:

1. Sign up for a free account at SocialTV
2. Click 'Create New Ad' in your dashboard
3. Choose a template from our library
4. Paste your social media video URL
5. Customize with your brand colors and logo
6. Preview your ad and generate a VAST tag

Your ad will be ready in under 5 minutes!`,
            views: 1234,
            helpful: 89,
            trending: true,
        },
        {
            id: 2,
            category: "getting-started",
            question: "What platforms can I import content from?",
            answer: `We support imports from all major social platforms:

• Instagram (Reels, Posts, Stories)
• TikTok
• Facebook (Videos, Reels)
• X (Twitter)
• Pinterest
• YouTube
• Vimeo

Simply paste the video URL and our AI will automatically optimize it for TV display.`,
            views: 2341,
            helpful: 95,
            popular: true,
        },
        {
            id: 3,
            category: "account",
            question: "How do I cancel my subscription?",
            answer: `To cancel your subscription:

1. Log into your SocialTV account
2. Go to Settings > Billing
3. Click 'Manage Subscription'
4. Select 'Cancel Subscription'
5. Confirm cancellation

Your access will continue until the end of your current billing period. No further charges will be made.`,
            views: 3456,
            helpful: 92,
            trending: true,
        },
        {
            id: 4,
            category: "account",
            question: "What payment methods do you accept?",
            answer: `We accept all major payment methods:

• Credit/Debit Cards (Visa, MasterCard, American Express)
• PayPal
• Bank transfers (for annual enterprise plans)
• Apple Pay
• Google Pay

All payments are processed securely through Stripe.`,
            views: 1567,
            helpful: 88,
        },
        {
            id: 5,
            category: "technical",
            question: "What is a VAST tag and how do I use it?",
            answer: `VAST (Video Ad Serving Template) is a universal format that allows video ads to be served across different platforms.

To use your VAST tag:

1. Create your ad in SocialTV
2. Copy the VAST tag URL from your dashboard
3. Paste it into your ad server (Google Ad Manager, The Trade Desk, etc.)
4. The ad server will pull your video and display it on CTV platforms

Your VAST tag is compatible with all major platforms including Roku, Amazon Fire TV, and Samsung TV Plus.`,
            views: 4321,
            helpful: 96,
            popular: true,
            trending: true,
        },
        {
            id: 6,
            category: "technical",
            question: "What video formats and resolutions do you support?",
            answer: `We support the following formats:

• Video: MP4, MOV, AVI
• Resolution: Up to 4K (3840x2160)
• Aspect Ratios: 16:9, 9:16, 1:1, 4:5
• Frame Rate: Up to 60fps
• Audio: AAC, MP3

Our platform automatically optimizes your video for the best quality on TV screens.`,
            views: 2876,
            helpful: 91,
        },
        {
            id: 7,
            category: "tutorials",
            question: "How do I add my logo and branding?",
            answer: `Adding your branding is easy:

1. In the ad editor, click 'Branding'
2. Upload your logo (PNG or SVG recommended)
3. Choose logo position
4. Select your brand colors for text overlays
5. Preview to see how it looks

Your branding will be automatically applied to all your ads.`,
            views: 1987,
            helpful: 94,
            popular: true,
        },
        {
            id: 8,
            category: "tutorials",
            question: "Can I schedule my ads to run at specific times?",
            answer: `Yes! With our Pro and Enterprise plans, you can:

• Set start and end dates for campaigns
• Schedule ads for specific times of day
• Target specific days of the week
• Set frequency caps per user
• Create custom schedules for different platforms`,
            views: 1654,
            helpful: 93,
        },
    ];

    const filteredFaqs = faqs.filter((faq) => {
        const matchesCategory =
            activeCategory === "all" ||
            faq.category === activeCategory;

        const matchesSearch =
            searchQuery === "" ||
            faq.question
                .toLowerCase()
                .includes(searchQuery.toLowerCase()) ||
            faq.answer
                .toLowerCase()
                .includes(searchQuery.toLowerCase());

        return matchesCategory && matchesSearch;
    });

    const handleFaqClick = (id) => {
        setExpandedFaq(expandedFaq === id ? null : id);
    };

    const handleFeedback = (faqId, type) => {
        setFeedback((prev) => ({
            ...prev,
            [faqId]: type,
        }));
    };

    const getCategoryColor = (categoryId) => {
        const colors = {
            "getting-started":
                "bg-[#FFF1EE] text-[#E85C4A] border-[#FFD9D2]",

            account:
                "bg-[#F5F7F6] text-[#3F5147] border-[#DFE7E2]",

            technical:
                "bg-[#F5F4F8] text-[#615B73] border-[#E4E1EB]",

            tutorials:
                "bg-[#FFF7ED] text-[#B96B2C] border-[#F4DFC8]",
        };

        return (
            colors[categoryId] ||
            "bg-[#F5F4F2] text-[#62666B] border-[#E5E2DF]"
        );
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-[#FCFAF8] text-[#17191C]">
            <BackToTop />

            {/* ================= HEADER ================= */}
            <Header
                loginClick={() => {
                    setShowAuth(true);
                }}
            />

            {/* ================= HERO ================= */}
            <section className="relative overflow-hidden bg-[#FCFAF8]">

                {/* Hero Background */}
                <div className="absolute inset-0 pointer-events-none">
                    <img
                        src={HeroBg}
                        loading="lazy"
                        sizes="100vw"
                        alt=""
                        className="
                            w-full
                            h-full
                            object-cover
                            opacity-[0.28]
                        "
                    />
                </div>

                {/* Soft white overlay */}
                <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-[#FCFAF8]/70 to-[#FCFAF8]" />

                {/* Coral glow */}
                <div
                    className="
                        absolute
                        -top-40
                        -right-40
                        w-[500px]
                        h-[500px]
                        rounded-full
                        bg-[#FF6968]/[0.07]
                        blur-[100px]
                    "
                />

                <div
                    className="
                        absolute
                        top-40
                        -left-40
                        w-[400px]
                        h-[400px]
                        rounded-full
                        bg-[#FFB0A9]/[0.08]
                        blur-[100px]
                    "
                />

                <main className="relative max-w-6xl mx-auto px-6">

                    <div
                        className="
                            min-h-[570px]
                            flex
                            items-center
                            justify-center
                            py-24
                        "
                    >
                        <div className="w-full max-w-4xl text-center">

                            {/* Small label */}
                            <div
                                className="
                                    inline-flex
                                    items-center
                                    gap-2
                                    px-4
                                    py-2
                                    rounded-full
                                    border
                                    border-[#E8E3DF]
                                    bg-white/80
                                    backdrop-blur-md
                                    shadow-sm
                                    mb-7
                                "
                            >
                                {/* <span className="w-2 h-2 rounded-full bg-[#FF6968]" /> */}

                                <Sparkles
                                    className="w-4 h-4 text-[#FF6968]"
                                />

                                <span
                                    className="
                                        text-sm
                                        font-semibold
                                        text-[#555B61]
                                    "
                                >
                                    24/7 Support
                                </span>
                            </div>

                            {/* Heading */}
                            <h1
                                className="
                                    text-4xl
                                    sm:text-5xl
                                    md:text-6xl
                                    lg:text-[68px]
                                    leading-[1.05]
                                    tracking-[-0.045em]
                                    font-semibold
                                    text-[#17191C]
                                    mb-7
                                "
                            >
                                How can we{" "}
                                <span className="text-[#FF6968]">
                                    help you?
                                </span>
                            </h1>

                            {/* Description */}
                            <p
                                className="
                                    max-w-2xl
                                    mx-auto
                                    text-base
                                    md:text-lg
                                    leading-relaxed
                                    text-[#70757B]
                                    mb-10
                                "
                            >
                                Search our help center or browse the topics
                                below to find answers and get the most from
                                SocialTV.
                            </p>

                            {/* Search */}
                            <div className="max-w-2xl mx-auto">
                                <div
                                    className={`
                                        relative
                                        transition-all
                                        duration-300
                                        ${searchFocused
                                            ? "scale-[1.02]"
                                            : ""
                                        }
                                    `}
                                >
                                    <Search
                                        className={`
                                            absolute
                                            left-5
                                            top-1/2
                                            -translate-y-1/2
                                            h-5
                                            w-5
                                            transition-colors
                                            duration-300
                                            ${searchFocused
                                                ? "text-[#FF6968]"
                                                : "text-[#9CA0A5]"
                                            }
                                        `}
                                    />

                                    <input
                                        type="text"
                                        placeholder="Search for answers..."
                                        value={searchQuery}
                                        onChange={(e) =>
                                            setSearchQuery(e.target.value)
                                        }
                                        onFocus={() =>
                                            setSearchFocused(true)
                                        }
                                        onBlur={() =>
                                            setSearchFocused(false)
                                        }
                                        className="
                                            w-full
                                            pl-14
                                            pr-12
                                            py-5
                                            rounded-2xl
                                            border
                                            border-[#E3DEDA]
                                            bg-white
                                            text-[#17191C]
                                            placeholder:text-[#9CA0A5]
                                            outline-none
                                            shadow-[0_15px_45px_rgba(30,24,20,0.07)]
                                            hover:border-[#D8D1CC]
                                            focus:border-[#FFAAA0]
                                            focus:ring-4
                                            focus:ring-[#FF6968]/10
                                            transition-all
                                        "
                                    />

                                    {searchQuery && (
                                        <button
                                            onClick={() =>
                                                setSearchQuery("")
                                            }
                                            className="
                                                absolute
                                                right-4
                                                top-1/2
                                                -translate-y-1/2
                                                w-8
                                                h-8
                                                rounded-full
                                                bg-[#F5F3F1]
                                                text-[#73777B]
                                                hover:bg-[#FFF0ED]
                                                hover:text-[#FF6968]
                                                transition-colors
                                            "
                                        >
                                            ×
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </section>

            {/* ================= CONTENT ================= */}
            <main className="max-w-6xl mx-auto px-6 pb-24">

                {/* FAQ Heading */}
                <div
                    className="
                        flex
                        flex-col
                        md:flex-row
                        md:items-end
                        md:justify-between
                        gap-5
                        mb-10
                    "
                >
                    <div>
                        <div className="flex items-center gap-3 mb-4">
                            <span className="w-8 h-px bg-[#FF6968]" />

                            <span
                                className="
                                    text-xs
                                    font-semibold
                                    uppercase
                                    tracking-[0.18em]
                                    text-[#FF6968]
                                "
                            >
                                Help Center
                            </span>
                        </div>

                        <h2
                            className="
                                text-3xl
                                md:text-4xl
                                font-semibold
                                tracking-[-0.035em]
                                text-[#17191C]
                            "
                        >
                            Frequently asked questions
                        </h2>

                        <p
                            className="
                                mt-3
                                text-[#757A7F]
                                max-w-xl
                                leading-relaxed
                            "
                        >
                            Find answers to common questions about
                            SocialTV, campaigns, billing and technical
                            setup.
                        </p>
                    </div>

                    {searchQuery && (
                        <span className="text-sm text-[#85898D]">
                            {filteredFaqs.length}{" "}
                            {filteredFaqs.length === 1
                                ? "result"
                                : "results"}{" "}
                            found
                        </span>
                    )}
                </div>

                {/* ================= CATEGORIES ================= */}
                <div className="mb-10">
                    <div className="flex flex-wrap gap-3">

                        {categories.map((category) => {
                            const Icon = category.icon;

                            const count =
                                category.id === "all"
                                    ? faqs.length
                                    : faqs.filter(
                                        (faq) =>
                                            faq.category ===
                                            category.id
                                    ).length;

                            const active =
                                activeCategory === category.id;

                            return (
                                <button
                                    key={category.id}
                                    onClick={() =>
                                        setActiveCategory(category.id)
                                    }
                                    className={`
                                        group
                                        inline-flex
                                        items-center
                                        gap-2
                                        px-4
                                        py-2.5
                                        rounded-xl
                                        text-sm
                                        font-medium
                                        border
                                        transition-all
                                        duration-300
                                        ${active
                                            ? "bg-[#FF6968] border-[#FF6968] text-white shadow-[0_8px_22px_rgba(255,105,104,0.20)]"
                                            : "bg-white border-[#E5E1DE] text-[#62676C] hover:border-[#FFB2A9] hover:bg-[#FFF8F6] hover:text-[#E85C4A]"
                                        }
                                    `}
                                >
                                    <Icon
                                        className={`
                                            w-4
                                            h-4
                                            ${active
                                                ? "text-white"
                                                : "text-[#8A8F94] group-hover:text-[#FF6968]"
                                            }
                                        `}
                                    />

                                    <span>
                                        {category.name}
                                    </span>

                                    <span
                                        className={`
                                            min-w-[22px]
                                            h-[22px]
                                            px-1.5
                                            inline-flex
                                            items-center
                                            justify-center
                                            rounded-full
                                            text-[11px]
                                            font-semibold
                                            ${active
                                                ? "bg-white/20 text-white"
                                                : "bg-[#F5F3F1] text-[#777C81]"
                                            }
                                        `}
                                    >
                                        {count}
                                    </span>
                                </button>
                            );
                        })}
                    </div>
                </div>

                {/* ================= FAQ ACCORDION ================= */}
                <div className="space-y-4">

                    {filteredFaqs.length > 0 ? (
                        filteredFaqs.map((faq) => {
                            const isOpen =
                                expandedFaq === faq.id;

                            const categoryName =
                                categories.find(
                                    (category) =>
                                        category.id === faq.category
                                )?.name;

                            return (
                                <div
                                    key={faq.id}
                                    className={`
                                        group
                                        overflow-hidden
                                        rounded-2xl
                                        border
                                        bg-white
                                        transition-all
                                        duration-300
                                        ${isOpen
                                            ? "border-[#FFB5AC] shadow-[0_15px_45px_rgba(40,30,25,0.07)]"
                                            : "border-[#E7E3E0] hover:border-[#FFBDB5] hover:shadow-[0_10px_35px_rgba(40,30,25,0.045)]"
                                        }
                                    `}
                                >

                                    {/* Question */}
                                    <button
                                        onClick={() =>
                                            handleFaqClick(faq.id)
                                        }
                                        className="
                                            w-full
                                            px-5
                                            sm:px-7
                                            py-6
                                            text-left
                                            flex
                                            items-center
                                            justify-between
                                            gap-5
                                        "
                                    >
                                        <div className="flex-1 min-w-0">

                                            {/* Badges */}
                                            <div
                                                className="
                                                    flex
                                                    flex-wrap
                                                    items-center
                                                    gap-2
                                                    mb-3
                                                "
                                            >
                                                <span
                                                    className={`
                                                        text-[11px]
                                                        font-semibold
                                                        px-2.5
                                                        py-1
                                                        rounded-full
                                                        border
                                                        ${getCategoryColor(
                                                        faq.category
                                                    )}
                                                    `}
                                                >
                                                    {categoryName}
                                                </span>

                                                {faq.trending && (
                                                    <span
                                                        className="
                                                            inline-flex
                                                            items-center
                                                            gap-1
                                                            text-[11px]
                                                            font-semibold
                                                            px-2.5
                                                            py-1
                                                            rounded-full
                                                            bg-[#FFF7ED]
                                                            text-[#B96B2C]
                                                            border
                                                            border-[#F4DFC8]
                                                        "
                                                    >
                                                        <TrendingUp className="w-3 h-3" />
                                                        Trending
                                                    </span>
                                                )}

                                                {faq.popular && (
                                                    <span
                                                        className="
                                                            inline-flex
                                                            items-center
                                                            gap-1
                                                            text-[11px]
                                                            font-semibold
                                                            px-2.5
                                                            py-1
                                                            rounded-full
                                                            bg-[#FFF1EE]
                                                            text-[#E85C4A]
                                                            border
                                                            border-[#FFD9D2]
                                                        "
                                                    >
                                                        <Star className="w-3 h-3 fill-current" />
                                                        Popular
                                                    </span>
                                                )}
                                            </div>

                                            {/* Question */}
                                            <span
                                                className={`
                                                    block
                                                    text-base
                                                    md:text-[17px]
                                                    font-semibold
                                                    leading-relaxed
                                                    transition-colors
                                                    ${isOpen
                                                        ? "text-[#E85C4A]"
                                                        : "text-[#202326] group-hover:text-[#E85C4A]"
                                                    }
                                                `}
                                            >
                                                {faq.question}
                                            </span>
                                        </div>

                                        {/* Arrow */}
                                        <div
                                            className={`
                                                flex
                                                flex-shrink-0
                                                items-center
                                                justify-center
                                                w-10
                                                h-10
                                                rounded-full
                                                transition-all
                                                duration-300
                                                ${isOpen
                                                    ? "bg-[#FFF0ED] rotate-180"
                                                    : "bg-[#F5F3F1] group-hover:bg-[#FFF0ED]"
                                                }
                                            `}
                                        >
                                            {isOpen ? (
                                                <ChevronUp
                                                    className="w-5 h-5 text-[#FF6968]"
                                                />
                                            ) : (
                                                <ChevronDown
                                                    className="
                                                        w-5
                                                        h-5
                                                        text-[#858A8F]
                                                        group-hover:text-[#FF6968]
                                                    "
                                                />
                                            )}
                                        </div>
                                    </button>

                                    {/* Answer */}
                                    <div
                                        className={`
                                            overflow-hidden
                                            transition-all
                                            duration-500
                                            ease-in-out
                                            ${isOpen
                                                ? "max-h-[2000px] opacity-100"
                                                : "max-h-0 opacity-0"
                                            }
                                        `}
                                    >
                                        {isOpen && (
                                            <div
                                                className="
                                                    px-5
                                                    sm:px-7
                                                    pb-7
                                                "
                                            >
                                                <div className="h-px bg-[#EEEAE6] mb-6" />

                                                <div
                                                    className="
                                                        max-w-4xl
                                                        text-[15px]
                                                        leading-8
                                                        text-[#666B70]
                                                        whitespace-pre-line
                                                    "
                                                >
                                                    {faq.answer}
                                                </div>

                                                {/* Meta */}
                                                <div
                                                    className="
                                                        flex
                                                        flex-col
                                                        lg:flex-row
                                                        lg:items-center
                                                        lg:justify-between
                                                        gap-5
                                                        mt-7
                                                        pt-5
                                                        border-t
                                                        border-[#EEEAE6]
                                                    "
                                                >
                                                    <div className="flex items-center gap-5">

                                                        <div
                                                            className="
                                                                flex
                                                                items-center
                                                                gap-2
                                                                text-sm
                                                                text-[#92969A]
                                                            "
                                                        >
                                                            <Eye className="w-4 h-4" />
                                                            {faq.views.toLocaleString()}
                                                            {" "}
                                                            views
                                                        </div>

                                                        <div
                                                            className="
                                                                flex
                                                                items-center
                                                                gap-2
                                                                text-sm
                                                                text-[#92969A]
                                                            "
                                                        >
                                                            <ThumbsUp className="w-4 h-4" />
                                                            {faq.helpful}%
                                                            {" "}
                                                            helpful
                                                        </div>

                                                    </div>

                                                    {/* Feedback */}
                                                    <div
                                                        className="
                                                            flex
                                                            items-center
                                                            gap-3
                                                        "
                                                    >
                                                        <span className="text-sm text-[#777C81]">
                                                            Was this helpful?
                                                        </span>

                                                        <div className="flex gap-2">

                                                            <button
                                                                onClick={() =>
                                                                    handleFeedback(
                                                                        faq.id,
                                                                        "yes"
                                                                    )
                                                                }
                                                                className={`
                                                                    w-9
                                                                    h-9
                                                                    rounded-lg
                                                                    flex
                                                                    items-center
                                                                    justify-center
                                                                    border
                                                                    transition-all
                                                                    duration-300
                                                                    hover:scale-105
                                                                    ${feedback[
                                                                        faq.id
                                                                    ] ===
                                                                        "yes"
                                                                        ? "bg-[#ECFDF3] border-[#B7E7C8] text-[#159447]"
                                                                        : "bg-white border-[#E4E0DD] text-[#9A9EA2] hover:bg-[#FFF8F6] hover:border-[#FFB5AC] hover:text-[#FF6968]"
                                                                    }
                                                                `}
                                                            >
                                                                <ThumbsUp className="w-4 h-4" />
                                                            </button>

                                                            <button
                                                                onClick={() =>
                                                                    handleFeedback(
                                                                        faq.id,
                                                                        "no"
                                                                    )
                                                                }
                                                                className={`
                                                                    w-9
                                                                    h-9
                                                                    rounded-lg
                                                                    flex
                                                                    items-center
                                                                    justify-center
                                                                    border
                                                                    transition-all
                                                                    duration-300
                                                                    hover:scale-105
                                                                    ${feedback[
                                                                        faq.id
                                                                    ] ===
                                                                        "no"
                                                                        ? "bg-[#FFF1F1] border-[#F2CACA] text-red-500"
                                                                        : "bg-white border-[#E4E0DD] text-[#9A9EA2] hover:bg-[#FFF8F6] hover:border-[#FFB5AC] hover:text-[#FF6968]"
                                                                    }
                                                                `}
                                                            >
                                                                <ThumbsDown className="w-4 h-4" />
                                                            </button>

                                                        </div>
                                                    </div>
                                                </div>

                                                {feedback[faq.id] && (
                                                    <div
                                                        className="
                                                            mt-5
                                                            inline-flex
                                                            items-center
                                                            gap-2
                                                            text-sm
                                                            font-medium
                                                            text-[#159447]
                                                        "
                                                    >
                                                        <CheckCircle className="w-4 h-4" />
                                                        Thank you for your feedback!
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div
                            className="
                                text-center
                                py-20
                                bg-white
                                rounded-2xl
                                border
                                border-[#E7E3E0]
                            "
                        >
                            <div
                                className="
                                    w-14
                                    h-14
                                    mx-auto
                                    mb-5
                                    rounded-full
                                    bg-[#FFF1EE]
                                    flex
                                    items-center
                                    justify-center
                                "
                            >
                                <HelpCircle
                                    className="
                                        w-7
                                        h-7
                                        text-[#FF6968]
                                    "
                                />
                            </div>

                            <h3
                                className="
                                    text-lg
                                    font-semibold
                                    text-[#17191C]
                                    mb-2
                                "
                            >
                                No results found
                            </h3>

                            <p className="text-[#777C81] text-sm">
                                No answers found for "{searchQuery}"
                            </p>

                            <button
                                onClick={() => setSearchQuery("")}
                                className="
                                    mt-5
                                    text-sm
                                    font-semibold
                                    text-[#FF6968]
                                    hover:text-[#E85C4A]
                                "
                            >
                                Clear search
                            </button>
                        </div>
                    )}
                </div>

                {/* ================= CONTACT ================= */}
                <section className="mt-24">

                    <div className="text-center mb-10">

                        <div
                            className="
                                flex
                                items-center
                                justify-center
                                gap-3
                                mb-4
                            "
                        >
                            <span className="w-8 h-px bg-[#FF6968]" />

                            <span
                                className="
                                    text-xs
                                    font-semibold
                                    tracking-[0.18em]
                                    uppercase
                                    text-[#FF6968]
                                "
                            >
                                Need more help?
                            </span>

                            <span className="w-8 h-px bg-[#FF6968]" />
                        </div>

                        <h2
                            className="
                                text-3xl
                                md:text-4xl
                                font-semibold
                                tracking-[-0.035em]
                                text-[#17191C]
                            "
                        >
                            We're here for you
                        </h2>

                        <p className="mt-3 text-[#777C81]">
                            Can't find what you're looking for?
                            Get in touch with our team.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 gap-5">

                        {/* Contact Support */}
                        <Link
                            to="/contact"
                            className="
                                group
                                relative
                                overflow-hidden
                                p-8
                                md:p-9
                                rounded-3xl
                                bg-[#FF6968]
                                text-white
                                transition-all
                                duration-500
                                hover:-translate-y-1
                                hover:shadow-[0_25px_55px_rgba(255,105,104,0.22)]
                            "
                        >
                            <div
                                className="
                                    absolute
                                    -right-20
                                    -top-20
                                    w-64
                                    h-64
                                    rounded-full
                                    bg-white/10
                                    blur-2xl
                                    group-hover:bg-white/15
                                    transition-all
                                "
                            />

                            <div className="relative z-10">

                                <div
                                    className="
                                        w-12
                                        h-12
                                        rounded-xl
                                        bg-white/15
                                        flex
                                        items-center
                                        justify-center
                                        mb-7
                                    "
                                >
                                    <MessageCircle className="w-6 h-6 text-white" />
                                </div>

                                <h3 className="text-2xl font-semibold mb-3">
                                    Contact support
                                </h3>

                                <p
                                    className="
                                        text-white/75
                                        mb-7
                                        max-w-sm
                                        leading-relaxed
                                    "
                                >
                                    Have a question or need help with
                                    your account? Our support team is
                                    ready to help.
                                </p>

                                <span
                                    className="
                                        inline-flex
                                        items-center
                                        gap-2
                                        text-sm
                                        font-semibold
                                    "
                                >
                                    Send message

                                    <ArrowRight
                                        className="
                                            w-4
                                            h-4
                                            group-hover:translate-x-1
                                            transition-transform
                                        "
                                    />
                                </span>
                            </div>
                        </Link>

                        {/* Email */}
                        <a
                            href="mailto:support@socialtv.com"
                            className="
                                group
                                relative
                                overflow-hidden
                                p-8
                                md:p-9
                                rounded-3xl
                                bg-white
                                border
                                border-[#E5E1DE]
                                transition-all
                                duration-500
                                hover:-translate-y-1
                                hover:border-[#FFB5AC]
                                hover:shadow-[0_25px_55px_rgba(40,30,25,0.07)]
                            "
                        >
                            <div
                                className="
                                    absolute
                                    -right-20
                                    -top-20
                                    w-56
                                    h-56
                                    rounded-full
                                    bg-[#FFF3F0]
                                    opacity-0
                                    group-hover:opacity-100
                                    transition-opacity
                                    duration-500
                                "
                            />

                            <div className="relative z-10">

                                <div
                                    className="
                                        w-12
                                        h-12
                                        rounded-xl
                                        bg-[#FFF1EE]
                                        border
                                        border-[#FFD9D2]
                                        flex
                                        items-center
                                        justify-center
                                        mb-7
                                    "
                                >
                                    <Mail className="w-6 h-6 text-[#FF6968]" />
                                </div>

                                <h3
                                    className="
                                        text-2xl
                                        font-semibold
                                        text-[#17191C]
                                        mb-3
                                    "
                                >
                                    Email us
                                </h3>

                                <p
                                    className="
                                        text-[#777C81]
                                        mb-7
                                        max-w-sm
                                        leading-relaxed
                                    "
                                >
                                    Send us your questions and our
                                    team will get back to you.
                                </p>

                                <div
                                    className="
                                        flex
                                        items-center
                                        justify-between
                                        gap-4
                                    "
                                >
                                    <span
                                        className="
                                            text-sm
                                            font-semibold
                                            text-[#FF6968]
                                        "
                                    >
                                        support@socialtv.com
                                    </span>

                                    <ArrowRight
                                        className="
                                            w-4
                                            h-4
                                            text-[#FF6968]
                                            group-hover:translate-x-1
                                            transition-transform
                                        "
                                    />
                                </div>
                            </div>
                        </a>
                    </div>
                </section>

                {/* ================= RESPONSE ================= */}
                <div className="mt-10 text-center">
                    <div
                        className="
                            inline-flex
                            items-center
                            gap-2
                            px-4
                            py-2
                            rounded-full
                            bg-white
                            border
                            border-[#E7E3E0]
                        "
                    >
                        <span className="w-1.5 h-1.5 rounded-full bg-[#4CAF72]" />

                        <p className="text-xs sm:text-sm text-[#777C81]">
                            Our support team typically responds within{" "}
                            <span className="font-semibold text-[#363A3E]">
                                24 hours
                            </span>
                        </p>
                    </div>
                </div>
            </main>

            {/* ================= AUTH POPUP ================= */}

            <AuthPopup
                isOpen={showAuth}
                onClose={() => setShowAuth(false)}
            />

            {/* ================= FOOTER ================= */}
            <Footer />
        </div>
    );
};

export default Support;